// #TX811_LINK_V1 (2026-11-02) — Bill: tapping a ticket # opens the live Texas811 ticket, no 811 login needed.
// The public ticket page is https://txgc.texas811.org/ui/ticket/<number>. Texas811 tickets are 10 digits; anything
// else (typo, blank, partial) gets no link and a red "!" so Hanna sees it before the field taps a dead page.
// An old ticket that has since been updated also opens "Ticket Not Found" — the slot needs the newest number.
export const tx811Num = (v) => String(v || '').replace(/\D/g, '');
export const tx811Valid = (v) => /^\d{10}$/.test(tx811Num(v)) && tx811Num(v).length === String(v || '').trim().length;
export const tx811Url = (v) => `https://txgc.texas811.org/ui/ticket/${tx811Num(v)}`;
